import chroma from 'chroma-js';
import React from 'react';
import { InputContainer, NoArrowNumberInput } from './styles';

interface RgbColor {
  red: number;
  green: number;
  blue: number;
}

interface ControllerProps {
  value: string;
  onChange(code: RgbColor): void;
}

export const RgbController: React.FC<ControllerProps> = ({ value, onChange }) => {
  const rgb_value: RgbColor = (() => {
    try {
      const [r, g, b] = chroma(value).rgba();
      return { red: r, green: g, blue: b };
    } catch (e) {
      return { red: 0, green: 0, blue: 0 };
    }
  })();
  const setRgbValue = (value: string, type: keyof RgbColor) => {
    onChange({ ...(rgb_value as RgbColor), [type]: Math.min(255, Number(value)) });
  };

  return (
    <InputContainer>
      <NoArrowNumberInput
        value={rgb_value?.red}
        onChange={(event) => setRgbValue(event.target.value, 'red')}
        data-testid='color-picker-controller-rgb-r-input'
      />
      <NoArrowNumberInput
        value={rgb_value?.green}
        onChange={(event) => setRgbValue(event.target.value, 'green')}
        data-testid='color-picker-controller-rgb-g-input'
      />
      <NoArrowNumberInput
        value={rgb_value?.blue}
        onChange={(event) => setRgbValue(event.target.value, 'blue')}
        data-testid='color-picker-controller-rgb-b-input'
      />
    </InputContainer>
  );
};
